'use strict';

$(function () {
	var v = 'is-visible';
	var f = 'is-fixed';
	var $header = $('.kissa-header');
	var $menubtn = $('.kissa-header ._menubtn');
	var $headerContent = $('.kissa-header-content');
	var pos = null;
	// メニュー開閉
	function closeMenu(restoreScroll) {
		$header.removeClass(v);
		document.documentElement.classList.remove(f);
		document.body.classList.remove(f);
		$headerContent.scrollTop(0);
		if (restoreScroll && pos !== null) {
			window.scrollTo(0, pos);
		}
		$menubtn.attr('aria-expanded', 'false');
	}
	function afterScrollUnlock(callback) {
		if (window.requestAnimationFrame) {
			window.requestAnimationFrame(function () {
				window.requestAnimationFrame(callback);
			});
		} else {
			window.setTimeout(callback, 0);
		}
	}
	$menubtn.on('click', function () {
		if ($header.hasClass(v)) {
			closeMenu(true);
		} else {
			$header.addClass(v);
			pos = document.body.scrollTop + document.documentElement.scrollTop;
			document.documentElement.classList.add(f);
			document.body.classList.add(f);
			$menubtn.attr('aria-expanded', 'true');
		}
	});

	function headerHeight() {
		return $(window).width() < 1024 ? 60 : 90;
	}

	function scrollToObject(_self, _speed) {
		var hash = '#' + _self.split('#')[1];
		var target = hash === '#pagetop' ? null : document.getElementById(hash.slice(1));
		var adjusted = false;
		function targetPos() {
			// offsetTop の積算で求める（offset() は js-inview のフェード分だけずれる）
			if (!target) {
				return 0;
			}
			var el = target;
			var y = 0;
			while (el) {
				y += el.offsetTop;
				el = el.offsetParent;
			}
			return y - headerHeight();
		}
		// アニメーション中にレイアウトが動いた場合に備え、完了後に再測定して補正する
		$('html,body').stop().animate({ scrollTop: targetPos() }, _speed, 'easeOutExpo', function () {
			if (adjusted) {
				return;
			}
			adjusted = true;
			var fixed = targetPos();
			if (Math.abs($(window).scrollTop() - fixed) > 1) {
				$('html,body').stop().animate({ scrollTop: fixed }, 200);
			}
		});
	}

	$(document).on('click', 'a[rel="scroll"]', function (event) {
		var speed = 1200;
		var href = event.currentTarget.href;
		if (!/#/.test(href)) {
			return false;
		}
		if ($header.hasClass(v)) {
			closeMenu(false);
			afterScrollUnlock(function () {
				scrollToObject(href, speed);
			});
		} else {
			scrollToObject(href, speed);
		}
		return false;
	});

	// 開閉ボタンのラベル切替と aria-expanded の同期
	var LABEL_CLOSE = 'とじる';
	function syncToggleLabel($btn) {
		if ($btn.data('labelOpen') === undefined) {
			$btn.data('labelOpen', $btn.text().replace(/^\s+|\s+$/g, ''));
		}
		var opened = $btn.hasClass('is-active');
		$btn.text(opened ? LABEL_CLOSE : $btn.data('labelOpen')).attr('aria-expanded', String(opened));
	}
	$('.js-more-toggle, .kissa-product-more, .kissa-news-more').each(function () {
		syncToggleLabel($(this));
	});

	$('.js-more-toggle').on('click', function () {
		$(this).toggleClass('is-active');
		syncToggleLabel($(this));
		$(this).next('.js-more-toggleBlock').stop().slideToggle(400);
	});

	// 商品バリエーション「もっとみる」（SPのみ有効。1件以下ならボタン非表示）
	$('.kissa-product-list').each(function () {
		var $list = $(this);
		var $more = $list.siblings('.kissa-product-more');
		if ($list.find('.kissa-product-list-li').length < 2) {
			$more.addClass('di_none');
		}
	});
	$('.kissa-product-more').on('click', function () {
		$(this).toggleClass('is-active');
		syncToggleLabel($(this));
		$(this).siblings('.kissa-product-list').toggleClass('is-open');
		$(window).trigger('scroll');
		setTimeout(function () {
			$(window).trigger('scroll');
		}, 400);
	});

	// お知らせ一覧「もっとみる」（初期4件→全件展開。5件目以降が無ければボタン非表示）
	var $newsList = $('.kissa-news-list');
	var $newsMore = $('.kissa-news-more');
	if ($newsList.children('.kissa-news-list-li').length < 5) {
		$newsMore.addClass('di_none');
	}
	$newsMore.on('click', function () {
		$(this).toggleClass('is-active');
		syncToggleLabel($(this));
		$newsList.toggleClass('is-open');
		$(window).trigger('scroll');
	});

	// MV自動再生の停止／再生トグル
	$('.kissa-mv-pause').on('click', function () {
		var $btn = $(this);
		var paused = $btn.hasClass('is-paused');
		$('.kissa-mv-slider').slick(paused ? 'slickPlay' : 'slickPause');
		$btn.toggleClass('is-paused').attr('aria-pressed', String(!paused)).attr('aria-label', paused ? '自動再生を停止' : '自動再生を再生');
	});

	$('.kissa-mv-slider').slick({
		infinite: true,
		speed: 1500,
		autoplay: true,
		pauseOnHover: false,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		arrows: false,
		dots: true,
		fade: true
	});

	// 追随型TOPボタン（FVでは非表示。MV高さを超えたら表示。フッター手前で停止）
	var $pagetop = $('.kissa-pagetop');
	var $mv = $('.kissa-mv');
	var $pagetopFooter = $('.kissa-footer');
	var pagetopBaseBottom = parseFloat($pagetop.css('bottom')) || 0;
	function updatePagetopStop() {
		var distanceFromBottom = $(document).height() - $(window).scrollTop() - $(window).height();
		var footerHeight = $pagetopFooter.length ? $pagetopFooter.outerHeight() : 0;
		if (distanceFromBottom < footerHeight) {
			$pagetop.css('bottom', pagetopBaseBottom + footerHeight - distanceFromBottom + 'px');
		} else {
			$pagetop.css('bottom', '');
		}
	}
	$(window).on('scroll', function () {
		var threshold = $mv.length ? $mv.offset().top + $mv.outerHeight() : 300;
		$pagetop.toggleClass('is-visible', $(this).scrollTop() > threshold);
		updatePagetopStop();
	});
	$(window).on('resize', updatePagetopStop);
	$pagetop.on('click', function () {
		scrollToObject('#pagetop', 800);
	});

	if ($('.js-inview').length) {
		$('.js-inview').waypoint(function (direction) {
			var activePoint = $(this.element);
			if (direction === 'down') {
				activePoint.addClass('is-active');
			} else if (!activePoint.data('inviewBottom')) {
				activePoint.removeClass('is-active');
			}
		}, {
			// 基本は画面高の 70%。ページ末尾の要素は最下部までスクロールしても 70% ラインに届かず
			// 発火しないため、最下部の手前で必ず発火する位置まで引き下げる（+80 は発火直後に戻した際の余裕）
			offset: function offset() {
				var winH = $(window).height();
				var rest = $(document).height() - $(this.element).offset().top;
				var base = winH * 0.7;
				var bottom = winH - rest + 80;
				// 引き下げた要素は画面内に見えたまま解除されてしまうため、上スクロールでは解除しない
				$(this.element).data('inviewBottom', bottom > base);
				return Math.max(base, bottom);
			}
		});
	}
});

var easeScrollHash = function easeScrollHash() {
	var hash = location.hash;
	if (hash) {
		document.documentElement.style.display = 'none';
		document.body.style.display = 'none';
		window.addEventListener('load', function () {
			setTimeout(function () {
				document.documentElement.style.display = 'block';
				document.body.style.display = 'block';
				// 存在しないIDのハッシュでは表示の復帰だけ行う
				var target = document.getElementById(hash.split('#')[1]);
				if (!target) {
					return;
				}
				var pos = target.getBoundingClientRect().top;
				pos -= window.innerWidth < 1024 ? 60 : 90;
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}, 100);
		});
	}
};
easeScrollHash();